// components/FileListComponent.tsx
import React, {useState} from 'react';

interface FileInfo {
    seq?: number;
    fileName: string;
    fileUrl: string;
    fileSize?: number;
}

interface FileListProps {
    files: FileInfo[];
}

const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'];

const isImageFile = (fileName: string) => {
    const ext = fileName.split('.').pop()?.toLowerCase() ?? '';
    return IMAGE_EXTENSIONS.includes(ext);
};

const FileListComponent: React.FC<FileListProps> = ({files}) => {
    const [previewUrl, setPreviewUrl] = useState<string | null>(null);

    if (!files || files.length === 0) {
        return null;
    }

    const formatFileSize = (bytes?: number) => {
        if (!bytes) return '';
        const mb = bytes / (1024 * 1024);
        return ` (${mb.toFixed(2)}MB)`;
    };

    return (
        <>
            <section>
                <div className="inner-box">
                    <ul className="file-wrap">
                        {files.map((file, index) => (
                            <li key={file.seq || index}>
                                {isImageFile(file.fileName) ? (
                                    <a
                                        href={file.fileUrl}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setPreviewUrl(file.fileUrl);
                                        }}
                                    >
                                        <p className="file-txt">
                                            <span className="file-tit">
                                                {file.fileName}{formatFileSize(file.fileSize)}
                                            </span>
                                            <span className="ico">
                                                <i className="fa-regular fa-image"></i>
                                            </span>
                                        </p>
                                    </a>
                                ) : (
                                    <a href={file.fileUrl} download={file.fileName}>
                                        <p className="file-txt">
                                            <span className="file-tit">
                                                {file.fileName}{formatFileSize(file.fileSize)}
                                            </span>
                                            <span className="ico">
                                                <i className="fa-solid fa-file-arrow-down"></i>
                                            </span>
                                        </p>
                                    </a>
                                )}
                            </li>
                        ))}
                    </ul>
                </div>
            </section>

            {previewUrl && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0, left: 0,
                        width: '100%', height: '100%',
                        backgroundColor: 'rgba(0,0,0,0.9)',
                        zIndex: 99999,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                    onClick={() => setPreviewUrl(null)}
                >
                    <button
                        style={{
                            position: 'absolute',
                            top: '16px', right: '16px',
                            background: 'none',
                            border: 'none',
                            color: '#fff',
                            fontSize: '2.8rem',
                            cursor: 'pointer',
                            zIndex: 100000,
                            padding: '8px',
                            lineHeight: 1,
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                            setPreviewUrl(null);
                        }}
                    >
                        <i className="fa-solid fa-xmark"></i>
                    </button>
                    <img
                        src={previewUrl}
                        alt="첨부 이미지"
                        style={{
                            maxWidth: '100%',
                            maxHeight: '100vh',
                            objectFit: 'contain',
                        }}
                        onClick={(e) => e.stopPropagation()}
                    />
                </div>
            )}
        </>
    );
};

export default FileListComponent;